/**
 * Holds properties used in the application.
 *
 * Eventually these should be made to be overridable serve side.
 */
import { envBoolean, envNumber, envString } from './envDefault'

export const BASE_NAME = envString('application.base.path', import.meta.env.PUBLIC_URL || '/app')!
export const RESOURCES_PATH = envString('resources.path', '')
export const OPEN_LAYERS_BASE_URL = envString('open.layers.base.url', 'https://ogc.ntlis.nt.gov.au')!
export const PLANNING_SERVICES_EMAIL = envString('planning.services.email', 'das.ntg@nt.gov.au')!
export const PLANNING_SERVICES_PHONE = envString('planning.services.phone', '(08) 8999 6046')!
export const PLANNING_SERVICES_PHONE_INTERNATIONAL = envString('planning.services.phone.international', '+61-08-8999-6046')!

export const PLACENAME_SERVICES_EMAIL = envString('placename.services.email', 'place.names@nt.gov.au')!
export const PLACENAME_SERVICES_PHONE = envString('placename.services.phone', '(08) 8995 5334')!
export const PLACENAME_SERVICES_PHONE_INTERNATIONAL = envString('placename.services.phone.international', '+61-08-8995-5334')!

export const AERIAL_PHOTO_SERVICES_EMAIL = envString('aerialphoto.services.email', 'landinfo@nt.gov.au')!

export const WARNING_NOT_SUPPORT_BROWSER_HEADER = 'This web browser is not supported for this website!'
export const WARNING_NOT_SUPPORT_BROWSER_MESSAGE = 'Please try a different browser'


export const WARNING_NO_COMPARABLE_PROPERTY_HEADER = 'No comparable properties found!'
export const WARNING_NO_COMPARABLE_PLANNING_PROPERTY_MESSAGE = `For more information, please contact Development 
                              Assessment Services on ${PLANNING_SERVICES_EMAIL} or phone: ${PLANNING_SERVICES_PHONE}`

export const ERROR_TITLE_PLACENAME_SEARCH_REGISTERED_DATE_RANGE = 'Invalid date range entry for Registered Date'
export const ERROR_MESSAGE_PLACENAME_SEARCH_REGISTERED_DATE_RANGE = '\'Registered Date To\' cannot be before the \'Registered Date From\'.'
export const ERROR_MESSAGE_PLACENAME_SEARCH_NO_FUTURE_DATE = 'Date cannot be in the future. Please enter a valid'

const APP_CONTEXT_PATH = envString('app.context.path', '/lsco-landsearch-app')!
export const ADDRESS_SEARCH_PATH = APP_CONTEXT_PATH + '/autoCompleteAddress/api/v1/'
export const REVERSE_GEOCODE_SEARCH_PATH = APP_CONTEXT_PATH + '/autoCompleteAddressReverse/api/v1/'
export const PLANNING_SEARCH_PATH = APP_CONTEXT_PATH + '/planning/api/v1/'
export const FLOOD_IMPACT_SEARCH_PATH = APP_CONTEXT_PATH + '/floodInfo/api/v1'
export const AP_SEARCH_PATH = APP_CONTEXT_PATH + '/aerialphotography/api/v1'
export const AP_CART_PATH = APP_CONTEXT_PATH + '/aerialphotography/cart/v1'
export const AP_IMAGE_PATH = APP_CONTEXT_PATH + '/aerialphotography/api/v1/image'

export const PLACENAME_SEARCH_PATH = APP_CONTEXT_PATH + '/autoCompletePlacename/api/v1'
export const PLACENAME_SEARCH_HOST = APP_CONTEXT_PATH + '/placenames/api/v1'
export const PLACENAME_SEARCH_FILTER = PLACENAME_SEARCH_HOST + '/items'
export const PLACENAME_DOCUMENT_BASE = PLACENAME_SEARCH_HOST + '/documents/'

export const PLACENAME_PUBLIC_APP_PATH = envString('nt.place.names.public.app.link', 'http://ilis-app-2uv.ntlis.nt.gov.au:8086/lsco-landsearch-app/app/placenames/')


export const DEVELOPMENT_PERMIT_DOCUMENT_HOST = envString('development.permit.document.host', '')!
export const DEVELOPMENT_PERMIT_DOCUMENT_PATH = envString('development.permit.document.path', '/ilis/planningPopup/lta.dar.viewDocument/')!

export const STRATEGIC_FRAMEWORK_LINK = envString('strategic.framework.link', 'https://nt.gov.au/property/land-planning-and-development/our-planning-system/nt-planning-scheme/strategic-framework-policies-and-land-use-plans')

export const NT_PLANNING_SCHEME_LINK = envString('nt.planning.scheme.link', 'https://nt.gov.au/property/land-planning-and-development/our-planning-system/nt-planning-scheme')
export const NT_PLACE_NAMES_COMMITTEE_LINK = envString('nt.place.names.committee.link', 'https://placenames.nt.gov.au/feedback')
export const NT_PLACE_NAMES_PRINT_LINK = envString('nt.place.names.print.link', 'http://ilis-app-2uv.ntlis.nt.gov.au:8086/placenames/print_extract.jsp')

export const NT_CONTACT_PLANNER_LINK = envString('nt.contact.planner.link', 'https://nt.gov.au/property/land-planning-and-development/contact-a-planner ')!
export const NT_LANDS_AND_PLANNING_LINK = envString('nt.lands.and.planning.link', 'https://nt.gov.au/property/land-planning-and-development/planning-applications-and-processes/apply-for-a-planning-certificate ')!

export const OPEN_LAYERS_LOT_BOUNDARIES_URL = envString('open.layers.lot.boundaries.url', OPEN_LAYERS_BASE_URL + '/mmapproxy/ntlis_mapproxy/service?')!
export const OPEN_LAYERS_LOT_BOUNDARIES_LAYER_NAME = envString('open.layers.lot.boundaries.layer.name', 'CADASTRE')!

export const OPEN_LAYERS_MAPPROXY_OSM_URL = envString('open.layers.mapproxy.osm.url', OPEN_LAYERS_BASE_URL + '/mmapproxy/osm/service?')!
export const OPEN_LAYERS_MAPPROXY_OSM_LAYER_NAME = envString('open.layers.mapproxy.osm.layer.name', 'osm')!

export const OPEN_LAYERS_PLACENAMES_LAYER_URL = envString('open.layers.placenames.layer.url', 'https://bas-app-28d.ntlis.nt.gov.au/gs/placenames/wms?')!
export const OPEN_LAYERS_PLACENAMES_LAYER_NAME = envString('open.layers.placenames.layer.name', 'placenames:PLACENAMES')!

export const LAYER_MAPMARKER_PRIMARY_COLOUR = envString('layer.mapmarker.primary.colour', 'rgba(243,118,53,0.9)')!
export const LAYER_MAPMARKER_NEIGHBOUR_COLOUR = envString('layer.mapmarker.neighbour.colour', '#0092da')!
export const OPEN_LAYERS_MAPMARKER_COLOUR_DEFAULT = envString('open.layers.mapmarker.colour.default', '#0092da')!
export const OPEN_LAYERS_MAPMARKER_COLOUR_XREF = envString('open.layers.mapmarker.colour.xref', '#00b300')!

export const RECAPTCHA_ENABLED = envBoolean('recaptcha.enabled', true)!
export const RECAPTCHA_V3_PUBLIC_SITE_KEY = envString('recaptcha.v3.public.site.key')!
export const RECAPTCHA_V2_PUBLIC_SITE_KEY = envString('recaptcha.v2.public.site.key')!

export const PARCEL_DATA_CACHING_TIMEOUT = envNumber('parcel.data.caching.timeout', 8 * 60 * 60 * 1000)! // This time should be in milliseconds

export const PLANNING_SUB_PATH = '/planningdetails'
export const LAYER_PLACE_NAMES_PATH = '/placenames'

export const PLACENAME_LOCATION_NOT_AVAILABLE_TITLE = 'Location information not available'
export const PLACENAME_LOCATION_NOT_AVAILABLE_MESSAGE_1 = 'Information for '

export const PLACENAME_LOCATION_NOT_AVAILABLE_MESSAGE_2 = ' provided, however map location data not available at this time.'

export const FLOOD_SUB_PATH = '/floodimpactmap'
export const FLOOD_MAP_OVERLAY = envString('flood.map.overlay', 'https://bas-app-28d.ntlis.nt.gov.au/mapproxy/service?')
export const MAP_PROJECTION = 'EPSG:3857'
export const MAPPROXY_PROJECTION = 'EPSG:4326'
export const RIVERINE_LAYER_NAME = 'FLOOD_DEPTH_RIVERINE'
export const STORM_LAYER_100y = 'FLOOD_DEPTH_STORM_SURGE_100Y'
export const STORM_LAYER_1000y = 'FLOOD_DEPTH_STORM_SURGE_1000Y'
export const FLOOD_LAYER_MIN_ZOOM = envNumber('flood.layer.min.zoom', 0)
export const RIVERINE = 'Riverine'
export const STORM_SURGE = 'Storm Surge'
export const STORM_100 = 'Storm_100y'
export const STORM_1000 = 'Storm_1000y'

export const PLACENAMES_HELP_URL = envString('placenames.help.url', 'https://placenames.nt.gov.au/register/help-and-more-information')
export const PLACENAMES_HELP_TITLE = envString('placenames.help.title', 'Information regarding this application')
export const PLACENAMES_HELP_LINK_TEXT = envString('placenames.help.link.text', 'Help')
export const PLACENAMES_MEDIA_HOST = envString('placenames.media.host', '/placenames-online/public/document/')

export const FLOOD_IMPACT_URL_ENABLED = envBoolean('flood.impact.url.enabled', false)
export const FLOOD_IMPACT_BUTTON_ENABLED = envBoolean('flood.impact.button.enabled', false)
export const FLOOD_IMPACT_MAP_CLICK_ENABLED = envBoolean('flood.impact.map.click.enabled', true)
export const PLANNING_MAP_CLICK_ENABLED = envBoolean('planning.map.click.enabled', true)
export const PLACENAMES_MAP_CLICK_ENABLED = envBoolean('placenames.map.click.enabled', true)
export const OPEN_LAYERS_WFS_NTLIS_PATH = envString('open.layers.wfs.ntlis.url', 'gs/ntlis/ows?')

export const FLOOD_POLYGON_COLOUR_FILL = envString('flood.polygon.colour.fill', 'rgba(160, 32, 240, 0)')!
export const FLOOD_POLYGON_COLOUR_STROKE = envString('flood.polygon.colour.stroke', 'rgb(160, 32, 240, 1)')!
export const FLOOD_POLYGON_COLOUR_WIDTH = envNumber('flood.polygon.colour.width', 1)!

export const LAYER_AERIAL_PHOTOGRAPHY_PATH= '/aerialphotography'
export const OPEN_LAYERS_AIR_PHOTO_PATH = envString('open.layers.air.photo.url', '/gs/airphoto/ows')!

/* these are the min/max radius for the advanced search -> search by coordinate, and in metres */
export const AP_POINT_RADIUS_MIN = envNumber('ap.point.radius.min', 1)
export const AP_POINT_RADIUS_MAX = envNumber('ap.point.radius.max', 10000)
